module.exports = __webpack_public_path__ + "img/img41.f3d609e9.svg";